import { render, staticRenderFns } from "./partnerList.vue?vue&type=template&id=c064449a&scoped=true&"
import script from "./partnerList.vue?vue&type=script&lang=js&"
export * from "./partnerList.vue?vue&type=script&lang=js&"
import style0 from "./partnerList.vue?vue&type=style&index=0&id=c064449a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c064449a",
  null
  
)

export default component.exports